<template>
	<main class="admin-layout" :class="{ 'observability-admin-layout': $route.name === 'ApiObservability' }">
		<admin-sidebar />
		<div class="admin-layout-body py-3 px-2">
			<router-view />
		</div>
	</main>
</template>

<script>
import AdminSidebar from '@shared_components/admin/components/common/sidebar'

export default {
	name: 'LayoutAdmin',
	components: {
		AdminSidebar,
	}
}
</script>

<style lang="scss">
$sidebar-width: 280px;

.admin-layout {
	display: flex;
	flex-wrap:wrap;
	height: 100%;
    width: 100%;
}

.admin-sidebar {
	position: fixed;
	height: 100vh;
	width: 100%;
	max-width: $sidebar-width;
	overflow-y: auto;
}

.admin-layout-body {
	margin-left: $sidebar-width;
	flex-grow: 1;
	height: 100%;
	min-height: 100vh;
	overflow-y: auto;
    background-color: #f8f9fa;
}

.admin-body-full-height {
	max-height: calc(100vh - 68px - 2rem);
	height: calc(100vh - 1.5rem);
}

.observability-admin-layout {
    min-width: 0;

    > .admin-layout-body {
        width: calc(100% - #{$sidebar-width});
        min-width: 0;
        flex: 0 1 calc(100% - #{$sidebar-width});
        padding: 0 !important;
    }

    @media (max-width: 760px) {
        display: block;

        > .admin-sidebar {
            position: static;
            width: 100%;
            max-width: none;
            height: auto;
            max-height: 260px;
            overflow-y: auto;
        }

        > .admin-layout-body {
            margin-left: 0;
            width: 100%;
            min-width: 0;
            flex-basis: auto;
        }
    }
}
</style>
